module.exports = __webpack_public_path__ + "img/20180103_114717-1.7a820a0e.jpg";